import { useSelector } from "react-redux";

import type { RootState } from "newui/store";
import type {
	Company,
	CorporateDocument,
	PastProject,
} from "newui/features/Company/types";

export interface DocumentAccessRequest {
	id: number;
	client_company: { id: number };
	client_company_id: number;
	document: { id: number } | null;
	document_id: number;
	is_approved: number;
	is_viewed: number;
}

interface CompanyPreviewData {
	company: Company | null;
	documentAccessRequests: DocumentAccessRequest[];
	documents: CorporateDocument[];
	isLoading: boolean;
	pastProjects: PastProject[];
	profileTypeId: number | null;
}

export const useCompanyPreviewData = (): CompanyPreviewData => {
	const company = useSelector(
		(state: RootState) => state.search.activeCompany as Company | null
	);
	const documents = useSelector(
		(state: RootState) =>
			(state.companyProfile.documents as CorporateDocument[]) ?? []
	);
	const documentAccessRequests = useSelector(
		(state: RootState) =>
			(state.companyProfile
				.document_access_requests as DocumentAccessRequest[]) ?? []
	);
	const pastProjects = useSelector(
		(state: RootState) =>
			(state.companyProfile.pastProjects as PastProject[]) ?? []
	);
	const isLoading = useSelector(
		(state: RootState) => state.search.isLoading as boolean
	);

	const profileTypeId = company?.profile_type?.id ?? null;

	return {
		company,
		documents,
		documentAccessRequests,
		pastProjects,
		isLoading,
		profileTypeId,
	};
};
